import {DeliveryMethod, DeliveryMethods, RestaurantTagTypes} from '~/shared/consts/restaurantConsts';
import {RestaurantBusinessTypeName, RestaurantFromSearch} from '~/shared/store/models';
import {EMPTY_ARRAY} from '~/shared/consts/commonConsts';
import {CuisinesFilterMethod, UiState} from '~/shared/store/storeModules/ui/uiReducer';

import {selectFilters} from '../index';

const isRestaurantMatchesCuisineFilter = (
  enabledCuisineFilters: string[],
  item: RestaurantFromSearch,
  cuisinesFilterMethod: UiState['restaurants']['cuisinesFilterMethod'],
) => {
  const restaurantCuisinesList = item.restaurantCuisineKeysList.reduce((acc, cuisine) => ({
    ...acc,
    [cuisine.toLowerCase()]: true,
  }), {});

  if (cuisinesFilterMethod === CuisinesFilterMethod.AND) {
    return enabledCuisineFilters.every(cuisine => cuisine.toLowerCase() in restaurantCuisinesList);
  }

  return enabledCuisineFilters.some(cuisine => cuisine.toLowerCase() in restaurantCuisinesList);
};

const filterRestaurantArr = (
  restaurants: RestaurantFromSearch[],
  cuisinesFilterMethod: UiState['restaurants']['cuisinesFilterMethod'],
  {
    isKosher,
    isNotKosher,
    isVegan,
    isGlutenFree,
    newRestaurants,
    freeDelivery,
    discountCoupon,
    isEnvironmentFriendly,
    isScoober,
    cuisines,
    showStores,
  }: ReturnType<typeof selectFilters>,
  deliveryMethod: DeliveryMethod,
  isCompanyAddressAndRestaurantWithoutVoucher?: boolean,
) => {
  const enabledCuisineFilters = cuisines ? Object.entries<boolean>(cuisines).reduce<string[]>((acc, [key, value]) => {
    if (!value) {
      return acc;
    }

    return [...acc, key];
  }, []) : EMPTY_ARRAY;

  return restaurants.filter(
    item => (isKosher ? item.isKosher : isNotKosher ? !item.isKosher : true) &&
      (!isVegan || item.isVegan) &&
      (!isEnvironmentFriendly || item.isEnvironmentFriendly) &&
      (!isScoober || item.isScoober || deliveryMethod === DeliveryMethods.PICKUP) &&
      (!isGlutenFree || item.isGlutenFree) &&
      (!freeDelivery || item.deliveryFee === 0 || (isCompanyAddressAndRestaurantWithoutVoucher && item.hasActivePoolRule)) &&
      (!newRestaurants || item.tags.some(({type}) => type === RestaurantTagTypes.NEW)) &&
      (!discountCoupon || item.tags.some(({type}) => type === RestaurantTagTypes.DISCOUNT_COUPON)) &&
      (!enabledCuisineFilters.length || isRestaurantMatchesCuisineFilter(enabledCuisineFilters, item, cuisinesFilterMethod)) &&
      (!showStores || item.businessTypeName === RestaurantBusinessTypeName.GroceryStore));
};

export default filterRestaurantArr;
